export const UNLAYER_EMAIL_TEMPLATE_LABELS = {
	showInsertClientNameTag: true,
	showAiTemplateFields: false,
	createButton: 'Create New',
	loadingTemplates: 'Loading templates...',
	emptyTemplates: 'No Unlayer templates found.',
	untitledTemplate: '(Untitled template)',
	loadTemplateError: 'Unable to load selected template.',
	createDrawerTitle: 'Create Template',
	editDrawerTitle: 'Edit Template',
	saveCreateSuccess: 'Template created.',
	saveUpdateSuccess: 'Template saved.',
	saveError: 'Unable to save template.',
	missingUserError: 'Unable to save template. Missing user or template context.',
	deleteSuccess: 'Template deleted.',
	deleteError: 'Unable to delete template.',
	deleteDialogTitle: 'Delete Template',
	deleteDialogBody: 'Deleting this template cannot be undone.',
	saveAsDialogTitle: 'Save as New Template',
	saveAsDialogBody:
		'Enter a name for the new template. Current designer content will be saved as a new template.',
	saveAsNameLabel: 'New Template Name',
	saveAsButton: 'Save as New',
	saveAsSuccess: 'Template saved as new.',
	saveAsError: 'Unable to save template as new.',
	saveAsMissingUserError: 'Unable to save template. Missing user context.',
	saveAsDrawerButton: 'Save as new template',
	createButtonLabel: 'Create',
	updateButtonLabel: 'Update',
};

export const UNLAYER_AI_EMAIL_TEMPLATE_LABELS = {
	showInsertClientNameTag: false,
	showAiTemplateFields: true,
	createButton: 'Create New AI Template',
	loadingTemplates: 'Loading AI templates...',
	emptyTemplates: 'No AI templates found. Create your first AI template using the button above.',
	untitledTemplate: '(Untitled AI template)',
	loadTemplateError: 'Unable to load selected AI template.',
	createDrawerTitle: 'Create AI Template',
	editDrawerTitle: 'Edit AI Template',
	saveCreateSuccess: 'AI template created.',
	saveUpdateSuccess: 'AI template saved.',
	saveError: 'Unable to save AI template.',
	missingUserError: 'Unable to save template. Missing user or template context.',
	deleteSuccess: 'AI template deleted.',
	deleteError: 'Unable to delete AI template.',
	deleteDialogTitle: 'Delete AI Template',
	deleteDialogBody: 'Deleting this AI template cannot be undone.',
	saveAsDialogTitle: 'Save as New AI Template',
	saveAsDialogBody:
		'Enter a name for the new AI template. Current designer content will be saved as a new AI template.',
	saveAsNameLabel: 'New AI Template Name',
	saveAsButton: 'Save as New AI Template',
	saveAsSuccess: 'AI template saved as new.',
	saveAsError: 'Unable to save AI template as new.',
	saveAsMissingUserError: 'Unable to save template. Missing user context.',
	saveAsDrawerButton: 'Save as new AI template',
	createButtonLabel: 'Create',
	updateButtonLabel: 'Update',
	activeColumnLabel: 'Active',
	activeDrawerTitle: 'Active template',
	masterFallbackLabel: 'Master',
	sharedWithColumnLabel: 'Shared with',
	shareDrawerButton: 'Share',
	shareGroupsLabel: 'Share with groups',
	shareGroupsHelper: 'This will share this AI template with all users in the selected group',
	shareSuccess: 'AI template sharing settings updated.',
	shareError: 'Unable to update AI template sharing settings.',
};
